@use '../../../scss/utility';

@use 'list-group-item-vars';
@use 'list-group-item-common';

:host {
  @include list-group-item-vars.wb-list-group-item-vars;
  @include list-group-item-common.wb-list-group-item;
}

:host(:not(:last-of-type)) {
  @include list-group-item-common.wb-list-group-item-not-last-of-type;
}

:host(.has-button) {
  @include list-group-item-vars.wb-list-group-item-button-vars;

  @include utility.breakpoint-from(mq4) {
    @include list-group-item-vars.wb-list-group-item-button-desktop-vars;
  }
}

.meta {
  @include list-group-item-common.wb-list-group-item-meta;

  &.no-slot-content {
    @include list-group-item-common.wb-list-group-item-meta-no-slot-content;
  }
}

slot[name='icon']::slotted(.wb-icon) {
  @include list-group-item-common.wb-list-group-item-icon;
}

:host([interactive]),
:host([href]) {
  @include list-group-item-common.wb-list-group-item-interactive-href;
}

:host([interactive]:hover),
:host([href]:hover) {
  @include list-group-item-vars.wb-list-group-item-hover-vars;
}

:host([interactive]:focus),
:host([href]:focus) {
  @include list-group-item-vars.wb-list-group-item-focus-vars;
  @include list-group-item-common.wb-list-group-item-interactive-href-focus;
}

:host([interactive]:active),
:host([href]:active) {
  @include list-group-item-vars.wb-list-group-item-active-vars;
  @include list-group-item-common.wb-list-group-item-interactive-href-active;
}

slot[name='button']::slotted(.wb-button) {
  @include list-group-item-common.wb-list-group-item-button;
}

slot[name='meta-icon']::slotted(.wb-icon) {
  @include list-group-item-common.wb-list-group-item-meta-icon;
}
